<template>
    <div class="main">
        <router-view></router-view>
    </div>
</template>
<style rel="stylesheet/css" lang="postcss" scoped>
    .main{
        padding: 10px 20px;
    }
</style>

<script>
    import { mapActions } from 'vuex'
    export default {
        data () {
            return {
            }
        },

        methods: {
            ...mapActions(['getUser'])
        },
        mounted () {

        }
    }
</script>



// WEBPACK FOOTER //
// Main.vue?6086dc40